import { render, staticRenderFns } from "./MoleculeEditionAssetContentCommentsReplies.vue?vue&type=template&id=79e44aba"
import script from "./MoleculeEditionAssetContentCommentsReplies.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionAssetContentCommentsReplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports